var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { makeStyles, Popper } from "@material-ui/core";
import clsx from "clsx";
export default React.forwardRef((_a, ref) => {
    var { className, children } = _a, otherProps = __rest(_a, ["className", "children"]);
    const classes = useStyles();
    return (React.createElement(Popper, Object.assign({ ref: ref, className: clsx(className, classes.root) }, otherProps), children));
});
const useStyles = makeStyles((theme) => ({
    root: {
        zIndex: theme.zIndex.snackbar,
    },
}));
//# sourceMappingURL=FTLPopper.js.map